import { render, staticRenderFns } from "./ProjectUpdate.vue?vue&type=template&id=2266d8ec&scoped=true&"
import script from "./ProjectUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUpdate.vue?vue&type=style&index=0&id=2266d8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2266d8ec",
  null
  
)

export default component.exports